import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main card-panel" }
const _hoisted_2 = { class: "duration-info" }
const _hoisted_3 = { class: "deep-purple-text" }
const _hoisted_4 = { class: "marquee" }
const _hoisted_5 = { class: "wave" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "skip_previous", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons right" }, "pause", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons right" }, "play_arrow", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "skip_next", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["TrackVisualizer"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.formatTime($setup.currTime) + ' \/ ' + $setup.formatTime($setup.duration)), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString($setup.trackName || 'Selected to play...'), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("button", {
      class: "btn waves-effect waves-light",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeTrack(-1)))
    }, _hoisted_7),
    _withDirectives(_createElementVNode("button", {
      class: "btn waves-effect waves-light",
      onClick: $setup.pause
    }, [
      _createTextVNode("Pause "),
      _hoisted_8
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.isPlaying]
    ]),
    _withDirectives(_createElementVNode("button", {
      class: "btn waves-effect waves-light",
      onClick: $setup.play
    }, [
      _createTextVNode("Play "),
      _hoisted_9
    ], 512 /* NEED_PATCH */), [
      [_vShow, !$setup.isPlaying]
    ]),
    _createElementVNode("button", {
      class: "btn waves-effect waves-light",
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTrack(1)))
    }, _hoisted_11)
  ]))
}